const REPORT_TOASTS = {
    DAILY_REPORT_NOT_FETCHED: "Failed to fetch daily report!",
    ORDER_NOT_ADDED: "Failed to add order",
    
}
export default REPORT_TOASTS